import request from '@/utils/httpRequest'

export function addmail (query) {
  return request({
    url: '/api/travel/web/mailbox/add',
    method: 'post',
    data: query
  })
}
// 多文件上传

export function uploads (query) {
  return request({
    url: '/api/file/uploads',
    method: 'post',
    // headers: {'Content-Type': 'multipart/form-data'},
    data: query
  })
}

// 获取留言列表
export function getliuyan (query) {
  return request({
    url: '/api/travel/web/mailbox/page',
    method: 'get',
    params: query
  })
}

// 获取问题列表
export function getIssue (query) {
  return request({
    url: '/api/travel/web/mailboxIssue/page',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/mailbox/index.js